import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DownloadLetterTemplateFileRequest = {
  letterTemplateId: number;
  filename: string;
};

export type DownloadLetterTemplateFileResponse = {};

export const downloadLetterTemplate = async (request: DownloadLetterTemplateFileRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.get(`/lettertemplates/${request.letterTemplateId}/download`, {
      responseType: "blob"
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", request.filename);
    document.body.appendChild(link);
    link.click();

    return response;
  }, false);
};
